import { AlertTriangle, Clock } from 'lucide-react';
import { BORDER_COLOR } from '../../styles/tokens';

// VNA-47 — Horas del empleado en OTROS proyectos el mismo día, a partir del payload de
// `/api/nomina/hours-check/batch` (que ya excluye la tarjeta abierta y cuenta todos los
// estados, borradores incluidos). Lo usan la tarjeta que se llena (TarjetaPage) y la que se
// revisa (TarjetaDetailPage): antes cada una tenía su copia y la de revisión no tenía
// ninguna, así que el revisor final veía "D: 11/8h" sin saber dónde estaban las otras horas.
// ⚠ Regulares Y extra: contar solo regulares escondía un proyecto con 0 R + 2 E.

const chipStyle = {
  fontSize: 10, fontWeight: 600, padding: '1px 6px', borderRadius: 10,
  background: '#fef3c7', color: '#92400e', border: '1px solid #fde68a',
};

function horas(reg, ext) {
  return ext > 0 ? `${reg.toFixed(1)}h R + ${ext.toFixed(1)}h E` : `${reg.toFixed(1)}h`;
}

function resumen(alerts) {
  const otherReg = alerts?.total_regular || 0;
  const otherExt = alerts?.total_overtime || 0;
  // Una fila con 0 R y 0 E (empleado listado sin horas en otra tarjeta) no es una alerta.
  const projects = (alerts?.projects || []).filter(p => (p.regular_hours || 0) + (p.overtime_hours || 0) > 0);
  const unsubmitted = alerts?.unsubmitted_sheets || [];
  return { otherReg, otherExt, projects, unsubmitted };
}

/** Chips para la cabecera de la tarjeta del empleado: "⚠ Otros" y "⏳ Sin someter". */
export function OtrosProyectosChips({ alerts }) {
  if (!alerts) return null;
  const { otherReg, otherExt, unsubmitted } = resumen(alerts);
  return (
    <>
      {otherReg + otherExt > 0 && (
        <span title={`${horas(otherReg, otherExt)} en otros proyectos hoy`} style={chipStyle}>
          ⚠ Otros: {horas(otherReg, otherExt)}
        </span>
      )}
      {unsubmitted.length > 0 && (
        <span title={`Tarjetas sin someter: ${unsubmitted.map(s => s.project_name).join(', ')}`} style={chipStyle}>
          ⏳ Sin someter: {unsubmitted.length}
        </span>
      )}
    </>
  );
}

/** Franja bajo la cabecera: en qué proyecto están esas horas. */
export function OtrosProyectosDetalle({ alerts }) {
  if (!alerts) return null;
  const { projects, unsubmitted } = resumen(alerts);
  if (projects.length === 0 && unsubmitted.length === 0) return null;
  return (
    <div style={{ padding: '4px 14px', background: '#fffbeb', borderBottom: `1px solid ${BORDER_COLOR}`, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
      {projects.map(p => (
        <span key={p.project_id} style={{ fontSize: 10, color: '#92400e', display: 'flex', alignItems: 'center', gap: 3 }}>
          <AlertTriangle size={10} /> {horas(p.regular_hours || 0, p.overtime_hours || 0)} en {p.project_name}
        </span>
      ))}
      {unsubmitted.length > 0 && (
        <span style={{ fontSize: 10, color: '#6b21a8', display: 'flex', alignItems: 'center', gap: 3 }}>
          <Clock size={10} /> Sin someter: {unsubmitted.map(s => s.project_name).join(', ')}
        </span>
      )}
    </div>
  );
}
